module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('strong', [_vm._v("1."), _c('br'), _vm._v("Have Fun")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0014-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("He who laughs, lasts.")]), _vm._v(" "), _c('p', {
    staticClass: "attribute"
  }, [_c('em', [_vm._v("Mary Pettibone Poole")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Sometimes when reading Goethe I have the paralyzing suspicion that he is trying to be funny.")]), _vm._v(" "), _c('p', {
    staticClass: "attribute"
  }, [_c('em', [_vm._v("Guy Davenport")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Seriousness is the only refuge of the shallow.")]), _vm._v(" "), _c('p', {
    staticClass: "attribute"
  }, [_c('em', [_vm._v("Oscar Wilde")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("It’s not by chance that I list having fun as my first suggestion on how to get your mind into idea-condition. Indeed, in my experience it might well be the most important one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here’s why:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Usually in creative departments of advertising agencies a writer and an art director work together as a team on a project. In some departments and occasionally in the ones that I headed, three or four teams work on the same project.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When that happened in my departments, I always knew which team would come up with the best ideas, the best ads, the best television commercials, the best billboards.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was the team that was having the most fun.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The ones with frowns and furrowed brows rarely got anything good.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The ones smiling and laughing almost always did.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Were they enjoying themselves because they were coming up with ideas? Or were they coming up with ideas because they were enjoying themselves?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The latter. No question about it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("After all, you know it’s true with everything else—people who enjoy what they’re doing, do it better. So why wouldn’t it be true with people who have to come up with ideas?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Make it fun to work at your agency,” said David Ogilvy, the head of an advertising agency. “When people aren’t having any fun they seldom produce good advertising.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Ogilvy did not have to limit his remarks to people in advertising agencies. The same could be said about anybody at any place who has to come up with an idea.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oh, I know that creating advertising is a minor creative endeavor, and you might consider it folly to apply the lessons learned there to more weighty occupations. But people in other fields say the same thing about fun.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Necessity may be the mother of invention,” said Roger von Oech, “but play is certainly the father.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Serious people have few ideas,” said Paul Valéry. “People with ideas are never serious.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The most exciting phrase to hear in science,” said author and biochemist Isaac Asimov, “the one that heralds new discoveries, is not ‘Eureka!’ (I found it!), but ‘That’s funny . . . ’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Indeed, it should come as no surprise that humor and all kinds of creativity are bedfellows.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("After all, as Arthur Koestler pointed out, the basis of humor is also the basis of creativity—the unexpected joining of dissimilar elements to form a new whole that actually makes sense; the sudden left turn when you were expecting the road to go straight; a “bisociation” (as Koestler puts it), two frames of reference slamming together.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just listen to how it works in humor:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How can I believe in God,” asked Woody Allen, “when just last week I got my tongue caught in the roller of an electric typewriter?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The race may not be to the swift nor the victory to the strong,” said Damon Runyon, “but that’s the way to bet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Shut up, he explained,” wrote Ring Lardner.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In every case your mind is going one way when suddenly you are forced to change directions and—wonder of wonders—this new, unanticipated direction is perfectly logical. Something new is created, something that after the fact often seems obvious.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ah, but that’s exactly what an idea is too. The unexpected joining of two “old elements” to create a new whole that makes sense, “two matrices of thought” (as Koestler puts it) meeting at the pass.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Johannes Gutenberg put a coin punch and a wine press together and got a printing press.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Salvador Dali put dreams and art together and got surrealism.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Someone put fire and food together and got cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("Sir Isaac Newton put the tides and the fall of an apple together and got gravity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Charles Darwin put human disasters and the proliferation of species together and got natural selection.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Levi Hutchins put an alarm and a clock together and got an alarm clock.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hyman L. Lipman put a pencil and an eraser together and got a pencil with an eraser.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Someone put a rag and a stick together and got a mop.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I once went for a job interview to an advertising agency in Chicago. As soon as I walked in I knew it would be a good place to work, a place where ideas would be bouncing off the ceiling. As I got off the elevator, there on the wall was this big official-looking framed sign:")]), _vm._v(" "), _c('div', {
    staticClass: "boxnote"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("IN CASE OF EMERGENCY")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("1. Grab your coat")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2. Get your hat")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("3. Leave your worries on the doorstep")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("4. Direct your feet to the sunny side of the street")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There they were framed and hanging on the wall— “two matrices of thought” meeting at the pass, two frames of reference slamming together. Humor and creativity. It’s difficult to have one without the other. The same is true for fun and ideas. And for enjoyment and performance.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("Let me tell you a story:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I started in advertising the writers and art directors dressed the way everybody in business dressed—the men wore suits and ties; the women, dresses or suits.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the late sixties all that changed. People started dressing in sweaters and blue jeans and T-shirts and tennis shoes. I was running a creative department then and the "), _c('em', [_vm._v("Los Angeles Times")]), _vm._v(" asked me what I thought about people coming to work like that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t care if they come to work in their pajamas,” I said, “as long as they get the work out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sure enough, the day after the article (with my quote) appeared, my entire department showed up in pajamas. It was great fun. The office rocked with laughter and joy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("More important, that day and the weeks that followed were some of the most productive times my department ever had. People were having fun, and the work got better.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Note again the cause and effect relationship: The fun came first; the better work, second. Having fun unleashes creativity. It is one of the seeds you plant to get ideas.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Realizing that, we started planting more of those seeds to make it fun to come to work. Perhaps a couple of them might work in your place, or will spark an idea for one that will work.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('em', [_vm._v("Meet in the Park")]), _vm._v(". Our office was across the street from a park. Once a month or so we’d hold a department meeting there. (It’s amazing how simply getting out of the office improved camaraderie and productivity.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', [_vm._v("Family Day")]), _vm._v(". Once a year, the kids came to see where mom and dad worked.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', [_vm._v("Darts")]), _vm._v(". We put up a dart board in our conference room and played darts when we needed a break.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', [_vm._v("Who Is That?")]), _vm._v(" People brought in pictures of themselves when they were babies. We tacked all the pictures on a wall, numbered them, and everybody tried to guess who was who. The person who got the most right won a prize.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', [_vm._v("Cute/Homely Baby")]), _vm._v(". Same as above, only we’d all vote on which baby was the cutest, which was the homeliest. Prizes, of course.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', [_vm._v("Arts and Crafts Fair")]), _vm._v(". People sold (or just exhibited) things they or their families made at home.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', [_vm._v("Hallway Hockey")]), _vm._v(". During lunch hour, we sometimes played hockey in the hallways with real hockey sticks, but with wads of paper for the puck.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', [_vm._v("Children’s Art")]), _vm._v(". Parents brought in their children’s art work, labeled it, and hung it in the lobby.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('em', [_vm._v("Chili Off")]), _vm._v(". The cooks in the department brought in pots of chili; we’d taste them and vote on a winner.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', [_vm._v("Dress-up Day")]), _vm._v(". Every now and then we’d all come in dressed to the nines.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', [_vm._v("Potluck")]), _vm._v(". Everybody brought in something, and we all sat down in the hallways and had lunch together.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("“If it isn’t fun, why do it?” says Jerry Greenfield of Ben & Jerry’s Ice Cream.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tom J. Peters agrees: “The number one premise in business is that it need not be boring or dull,” he wrote. “It ought to be fun. If it’s not fun, you’re wasting your life.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Don’t waste yours. Have some fun.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And not so incidentally, come up with some ideas.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0024-01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c385f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 87
// module chunks = 0